// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__1NnDO","wrapper":"styles_wrapper__BPbtF"};